/**
 * Sticky KPI bar (`#kpi-bar`, phones only — CSS hides it above 640 px).
 *
 * The bar duplicates платёж / переплата / срок from the result strip under the form, so it
 * is hidden while any part of the strip (`#result`) or its tiles (`.summary-grid`) is on
 * screen and shown otherwise; tapping it scrolls the tiles into view. Values are written by
 * `updateKpiBar` in `summary.ts`.
 */

const BAR_ID = 'kpi-bar';
const SUMMARY_SELECTOR = '.summary-grid';
const RESULT_SELECTOR = '#result';

function barHeight(bar: HTMLElement): number {
  const height = bar.getBoundingClientRect().height;
  if (height > 0) return height;
  const declared = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--kpi-bar-height'));
  return Number.isFinite(declared) ? declared : 72;
}

export function initKpiBar(): void {
  const bar = document.getElementById(BAR_ID);
  const summary = document.querySelector<HTMLElement>(SUMMARY_SELECTOR);
  if (!bar || !summary) return;

  bar.querySelector('[data-action="scroll-summary"]')?.addEventListener('click', () => {
    summary.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  if (typeof IntersectionObserver === 'undefined') {
    bar.hidden = false;
    return;
  }

  // The bottom margin excludes the strip covered by the bar itself, so a block that is only
  // "visible" underneath the bar still counts as off-screen.
  const visible = new Map<Element, boolean>();
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => visible.set(entry.target, entry.isIntersecting));
      bar.hidden = Array.from(visible.values()).some(Boolean);
    },
    { threshold: 0, rootMargin: `0px 0px -${Math.round(barHeight(bar))}px 0px` },
  );
  observer.observe(summary);
  const result = document.querySelector<HTMLElement>(RESULT_SELECTOR);
  if (result) observer.observe(result);
}
